import React, { Component } from 'react';
import LoginForm from './loginForm/LoginForm';
import './Login.scss';

class Login extends Component {
    render() {
        return (
            <div className="login">
                <div className="loginBox">
                    <h2>Login</h2>
                    <LoginForm />
                </div>
            </div>
        );
    }
}

export default Login;